// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
html {
    overflow: hidden;
}

.editable.icon {
    display: flex;
}

.editable.icon::after {
    color: var(--black-25);
    content: '\\e3c9';
    font-size: 20px;
    position: relative;
    width: 18px;
    top: -4px;
    right: -3px;
    overflow: hidden;
    font-family: 'Material Symbols Outlined';
}

.editable.error.icon::after {
    color: var(--red-1);
}

.editable.icon:has(.edit)::after {
    display: none;
}

.editable.error {
    color: var(--red-1);
    text-decoration:underline wavy;
    z-index: 999;
    position: relative;
}

.editable > .empty {
    font-style: italic;
    color: var(--black-35);
}

.editable > .error {
    display: none;
    z-index: 999;
    position:absolute;

    text-decoration: none;

    min-width: 160px;
    bottom: -30px;
    left: 0px;
    background-color: var(--black-05);
    color: var(--red-1);
    padding-left: 4px;
    padding-right: 4px;
    padding-bottom: 6px;

    border: solid 1px;
    border-radius: 8px;

    cursor: pointer;
    user-select: none; 
}

.editable.error:hover > .error  {
    display: block;
}

.editable > .error::before {
    content: '\\e645';
    font-size: 15px;
    position: relative;
    top: 3px;
    overflow: hidden;
    font-family: 'Material Symbols Outlined';
}

.snapper {
    position: relative;
    border-radius: 4px;
    background-color: var(--black-10);
    padding-left: 4px;
}

/* The session picker opens its menu on click. The open menu is a descendant, so
   a plain :hover would stay lit while the pointer is down inside the menu. */
.snapper:not(:has(> .snap-menu)):hover {
    background-image: linear-gradient(var(--hover-veil), var(--hover-veil));
}

.snapper.midi-learn::after {
    height: 100%;
    width: 100%;
}

.snapper .fullname {
    display:none;
    position: absolute;

    height: 20px;
    width: fit-content;

    padding: 6px;
    border-radius: 4px;

    left: -4px;
    top: -10px;

    background-color: var(--black-15);
    font-size: 10px;

    cursor: pointer;
    user-select: none; 

}

.snapper > .name {
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.325px;
    color: var(--black-75);
    padding-left: 6px;
    width: 168px;

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 70%, transparent 100%);

    user-select: none; 
}

.snapper > .expando {
    position: absolute;
    right: 4px;
    font-size: 24px;
    font-weight: normal;
}

.snapper > .snap-menu {
    z-index: 999;
    position: absolute;
    padding-bottom: 10px;
    padding-left: 6px;
    left: -6px;
    top: 34px;
    width: 282px;
    border-radius: 4px;
    border: 1px solid var(--black-10);

    font-size: 14px;

    display: flex;
    flex-direction: column;
    background-color: var(--black-02);
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);

    max-height: min(1200px, 90vh);
    overflow: visible;
}

/* Override inline positioning and visual styles on nested MenuChoices */
.snapper > .snap-menu > .menu-list,
.snapper > .snap-menu > .sessions-scroll > .menu-list {
    position: static !important;
    z-index: auto !important;
    /* Remove visual separators */
    border: none;
    border-radius: 0;
    background: transparent;
    margin: 0;
    padding: 0;
}

.snapper > .snap-menu > .sessions-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}

.snapper > .snap-menu .action,
.snapper > .snap-menu .session,
.snapper > .snap-menu .header {
    cursor: pointer;
    user-select: none; 
}

.snapper > .snap-menu .action.submenu {
    display: flex;
    justify-content: space-between;
}

.snapper > .snap-menu .action.submenu .trigger {
    padding-left: 10px;
    padding-right: 10px;
}

.snapper > .snap-menu .action,
.snapper > .snap-menu .session {
    color: var(--black-80);
}

.snapper > .snap-menu .session,
.snapper > .snap-menu .search {
    padding-left: 10px;
}

.snapper > .snap-menu .header {
    font-size: 14px;
    color: var(--black-45);
}

.snapper > .snap-menu .session {
    position: relative;
    width: 264px;

    display: flex;
    align-items: center;
}

.snapper > .snap-menu .session.empty {
    font-style: italic;
    color: var(--black-45);
}

.snapper > .snap-menu .session .name {
    width: 204px;

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 70%, transparent 100%);
}

.snapper > .snap-menu .session .locked.immutable {
    color: var(--black-80);
}

.snapper > .snap-menu .session .loaded,
.snapper > .snap-menu .session .locked {
    position: absolute;
    font-family: 'Material Symbols Outlined';
    font-size: 18px;
}

.snapper > .snap-menu .session .loaded {
    right: 5px;
}

.snapper > .snap-menu .session .locked {
    right: 24px;
}

/* Row without the check (the \`loaded\` class sits on the row, the icon is a
   child of the same name): the lock takes the check's slot instead of hanging
   short of the edge */
.snapper > .snap-menu .session:not(.loaded) .locked {
    right: 5px;
}

.snapper > .snap-menu .snaps .header {
    color: var(--black-45);
    font-size: 12px;
}

.snapper > .snap-menu .snaps .items {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
}

/* compensate for padding of container */
.snapper > .snap-menu .snaps .items > .session:first-child {
    padding-top: 3px;
}

.snapper > .snap-menu .action:not(.disabled):hover,
.snapper > .snap-menu .session:hover {
    color: var(--black-90);
    background-color: var(--black-20);
    border-radius: 2px;
}

.snapper > .snap-menu .action.disabled {
    color: var(--black-45);
}

.snapper > .snap-menu .action {
    position: relative;

    display: flex;
    align-items: center;
}

.snapper > .snap-menu .search {
    padding-left: 7px;
}

.snapper > .snap-menu .search .icon {
    position: absolute;
    left: 14px;
    font-size: 22px;
    color: var(--black-45);
    user-select: none; 
}

.snapper > .snap-menu .searchbox {
    font-size: 14px;
  
    width: 250px;
    height: 32px;
    /** if missing, caret appears in upper left of searchbox when empty (and focused) */
    padding: 0;
    padding-left: 33px;

    color: var(--black-65);
    background-color: var(--black-10);

    border: solid var(--black-15) 1px;
    border-radius: 4px;

    /** prevents default outlining of active input text box */
    outline: none;

    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.snapper > .snap-menu .searchbox {
    letter-spacing: 0;
}

.snapper > .snap-menu .searchbox.hidden {
    display: none;
}
  
.snapper > .snap-menu .searchbox.empty {
    color: var(--black-45);
    user-select: none; 
}

.snapper > .snap-menu .searchbox.edit {
    font-style: normal;
    text-overflow: clip;
    overflow: hidden;
    color: var(--black-80);
    background-color: var(--black-20);
}

.snapper > .snap-menu .action .icon {
    font-family: 'Material Symbols Outlined';
    font-size: 18px;
    width: 24px;
}

/* Status banner under the header (Figma "Frame 622", node 3463:60780):
   red wash, red text, chevron collapse. Spans the content column. */
.app-banner {
    position: fixed;
    top: 72px;
    /* Gosta (round 6): one 20px inset for all tabs/buttons and chains */
    left: 400px;
    right: 24px;
    padding: 6px 12px 14px;
    border-radius: 4px;
    z-index: 5;
    user-select: none;
}

.app-banner.danger {
    background-color: rgba(255, 0, 0, 0.15);
    color: #d90b0b;
}

.app-banner .head {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
}

.app-banner .chevron {
    font-size: 24px;
}

.app-banner .title {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.26px;
}

.app-banner .body {
    font-size: 13px;
    letter-spacing: 0.26px;
    padding-left: 32px;
    margin-top: 2px;
}

.app-banner.collapsed {
    padding-bottom: 6px;
}

.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 999;
    overflow: hidden;
}

/* Non-blocking variant: click-through overlay, dialog still interactive */
.modal.offline {
    background-color: transparent;
    pointer-events: none;
}
.modal.offline .dialog {
    pointer-events: auto;
}

.modal .dialog {
    font-size: 14px;
    position: absolute;
    top: 33%;
    left: 50%;
    width: 400px;
    transform: translate(-50%, -50%);

    padding-bottom: 10px;

    color: var(--black-80);
    background-color: var(--ui-modal-bg);

    box-shadow: var(--ui-modal-shadow);
    border-radius: var(--ui-modal-radius);

}

.modal .dialog .titlebar {
    position: relative;
    width: 100%;
    height: var(--ui-modal-header-height);

    border-top-right-radius: var(--ui-modal-radius);
    border-top-left-radius: var(--ui-modal-radius);

    font-size: 15px;
    font-weight: 700;
    text-transform: uppercase;
    /* Explicit: Figma titlebar text is #cdcdce (var --Color). Without this
       the title inherits whatever body color a dialog variant sets, e.g. the
       demo dialog's --black-65. */
    color: var(--black-80);

    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;

    background-color: var(--ui-modal-header-bg);

    user-select: none;
}

.modal .dialog .titlebar .dismiss {
    position: absolute;
    /* 10px inset and the thin (wght 300) close glyph per Figma nodes
       3495:40276 / 3495:40243. font-weight must match the 300 face:
       the titlebar's 700 would synthetic-bold the glyph back to thick. */
    right: 10px;
    top: 5px;
    font-size: 24px;
    font-weight: 300;
    /* 24x24 box like the Figma icon; line-height normal would grow it to
       29px and sink the glyph below center. */
    line-height: 1;
    color: var(--black-80);
    font-family: 'Material Symbols Outlined Thin', 'Material Symbols Outlined';
}

.modal .dialog .titlebar .dismiss:hover {
    filter: brightness(1.2);
}

/* Figma dialog body copy: Inter Medium 15px, --black-85, 2.5% tracking
   (node 3495:40276). Keep this low-specificity so purpose-built dialogs can
   override the shared type scale without duplicating the base treatment. */
.modal .dialog > .body > :where(.prompt, .message) {
    font-weight: 500;
    font-size: 15px;
    line-height: normal;
    letter-spacing: 0.025em;
    color: var(--black-85);
}

.modal .dialog > .body > .prompt {
    user-select: none;
    padding: 10px;
    width: 100%;

    display:flex;
    align-content: center;
    justify-content: center;
    text-align: center;
}

.modal .dialog .edit {
    background-color: var(--black-02);
    padding: 5px;
    border-radius: 6px;
}

.modal .dialog > .body > .prompt > ul > li {
    list-style-type: square;
}

.modal .dialog > .body {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 14px;
    margin-bottom: 14px;

    display:flex;
    flex-direction: column;
    justify-content: space-around;
    gap: 18px;
}

.modal .dialog > .body .message {
    padding-left: 10px;
    white-space: pre-line;
}

/* Figma dialog footer: 120px buttons with an 8px gap (node 3495:40276) */
.modal .dialog .actions {
    display: flex;
    gap: 8px;
    justify-content: center;
}

.modal .dialog .actions .cta {
    width: 120px;
    height: 32px;
    background-color: var(--ui-button-bg-primary);
    color: var(--ui-button-text-primary);
}

.modal .dialog .actions .cta.secondary {
    background-color: transparent;
    color: var(--ui-button-text-secondary);
}

/* Disabled reads as inert: gray fill, dim label — not the primary blue with
   washed-out text it used to keep */
.modal .dialog .actions .cta.disabled  {
    background-color: var(--black-15);
    color: var(--black-45);
    font-weight: normal;
}

.modal .dialog .actions .cta.selected:not(.disabled) {
    border: 2px solid var(--black-45);
    font-weight: 500;
}

.modal .dialog .actions .cta:hover:not(.disabled) {
    color: var(--ui-button-text-primary);
    filter: brightness(1.1);
}

.modal .dialog .actions .cta.secondary:hover {
    color: var(--black-80);
    filter: none;
}

.modal .dialog .actions .cta:hover.disabled {
    background-color: var(--black-15);
}

.modal .dialog.alert {
    width: 360px;
}

.modal .dialog.alert .titlebar,
.modal .dialog.destructive .titlebar {
    background-color: var(--ui-modal-header-bg-danger);
    color: var(--ui-modal-header-text-danger);
}

.modal .dialog.alert .actions {
    justify-content: center;
}

.modal .dialog.alert .actions .cta,
.modal .dialog.destructive .actions .cta.primary {
    color: var(--ui-modal-header-text-danger);
    background-color: var(--ui-modal-header-bg-danger);
}

.modal .dialog.alert .actions .cta:hover,
.modal .dialog.destructive .actions .cta.primary:hover {
    background-color: var(--ui-modal-header-bg-danger);
    filter: brightness(1.1);
}

.modal .dialog.alert .dismiss,
.modal .dialog.destructive .dismiss {
    color: var(--ui-modal-header-text-danger);
}

.modal .dialog.destructive .actions .cta.secondary.danger,
.modal .dialog.destructive .actions .cta.secondary.danger:hover {
    color: var(--ui-modal-header-bg-danger);
}

/* The three-outcome Save Changes flow only needs room for its third CTA.
   Typography and alignment come from the shared dialog treatment above. */
.modal .dialog.destructive.three-outcome {
    width: 460px;
}

.modal .dialog.alert > .body .message {
    text-align: center;
    padding-inline: 10px;
}

/* OFFLINE dialog uses the app-chrome blue, not the dialog header blue (Figma node 3495:40286) */
.modal.offline .dialog .titlebar {
    background-color: var(--blue-1);
}

.modal.offline .dialog .actions .cta {
    background-color: var(--blue-1);
    color: var(--black-80);
}

.modal.offline .dialog .actions .cta.secondary {
    background-color: transparent;
    color: var(--ui-button-text-secondary);
}

.modal .dialog.alert > .body {
    margin: 24px 20px 20px;
    gap: 20px;
}

/* App Info Dialog - Enhanced Styling */
.modal .dialog.app-info-dialog {
    width: 420px;
}

.modal .dialog.app-info-dialog > .body {
    gap: 16px;
}

.modal .dialog.app-info-dialog .prompt {
    font-size: 13px;
    color: var(--black-65);
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 4px;
}

.app-info-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.app-info-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 10px 12px;
    background: var(--black-02);
    border-radius: 4px;
}

.app-info-row {
    display: flex;
    align-items: baseline;
    gap: 8px;
}

.app-info-key {
    min-width: 90px;
    font-size: 12px;
    font-weight: 500;
    color: var(--black-45);
    text-transform: lowercase;
    letter-spacing: 0.02em;
}

.app-info-key::after {
    content: ':';
}

.app-info-value {
    font-size: 13px;
    font-weight: 500;
    color: var(--black-80);
    letter-spacing: 0.025em;
}

.release-notes-link {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 16px;
    margin-top: 4px;
    background: var(--black-02);
    border: 1px solid var(--black-15);
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
    font-size: 13px;
    color: var(--black-65);
}

.release-notes-link:hover {
    background: var(--black-07);
    border-color: var(--blue-2);
    color: var(--black-80);
}

.release-notes-icon {
    font-size: 8px;
    color: var(--blue-2);
    opacity: 0.7;
}

.release-notes-link:hover .release-notes-icon {
    opacity: 1;
}

.release-notes-chevron {
    font-size: 16px;
    margin-left: auto;
    opacity: 0.5;
    transition: transform 0.15s ease;
}

.release-notes-link:hover .release-notes-chevron {
    opacity: 1;
    transform: translateX(2px);
}

/* Create Session Dialog */
/* SUPPORT DIALOG */

.modal.support .field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.modal.support .field .field-label {
    font-size: 13px;
    color: var(--black-65);
    font-weight: 500;
}

.modal.support .field .value {
    background-color: var(--black-10);
    padding: 8px 10px;
    border-radius: 4px;
    font-size: 14px;
}

.modal.support .support-input,
.modal.support .support-message {
    background-color: var(--black-10);
    color: inherit;
    font-family: inherit;
    font-size: 14px;
    padding: 8px 10px;
    border-radius: 4px;
    border: none;
    outline: none;
    resize: vertical;
}

.modal.support .app-info-content { gap: 6px; }
.modal.support .app-info-group { padding: 5px 8px; gap: 2px; border-left-width: 2px; }
.modal.support .app-info-key { font-size: 10px; min-width: 70px; }
.modal.support .app-info-value { font-size: 11px; }

.modal.support .prompt {
    font-size: 11px;
    font-weight: 400;
    color: var(--black-40);
}

.modal.support .support-input.error {
    outline: 1px solid #c54040;
}

.modal.support .version-stale {
    font-size: 11px;
    color: #c57600;
    font-weight: 500;
    margin-top: 2px;
}

.modal.support .checkbox-row {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;
}
.modal.support .checkbox-row.disabled { cursor: default; }
.modal.support .checkbox-row.disabled .text { color: var(--black-45); }
.modal.support .checkbox-row .checkbox {
    font-family: 'Material Symbols Outlined';
    font-size: 20px;
    color: var(--black-65);
}
.modal.support .checkbox-row.disabled .checkbox { color: var(--black-35); }
.modal.support .checkbox-row .text { font-size: 14px; color: var(--black-80); }

/* CREATE SESSION DIALOG */

.modal.create-session .dialog {
    width: 420px;
}

.modal.create-session .dialog .body {
    gap: 16px;
}

.modal.create-session .field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.modal.create-session .field .label {
    font-size: 13px;
    color: var(--black-65);
    font-weight: 500;
}

.modal.create-session .field .value {
    background-color: var(--black-10);
    padding: 8px 10px;
    border-radius: 4px;
    font-size: 14px;
}

.modal.create-session .options {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.modal.create-session .option {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 4px;
    background-color: var(--black-05);
    cursor: pointer;
    user-select: none;
}

.modal.create-session .option:hover {
    background-color: var(--black-15);
}

.modal.create-session .option.selected {
    background-color: var(--black-15);
}

.modal.create-session .option .radio {
    font-family: 'Material Symbols Outlined';
    font-size: 20px;
    color: var(--black-65);
}

.modal.create-session .option.selected .radio {
    color: var(--blue-2);
}

.modal.create-session .option .text {
    font-size: 14px;
    color: var(--black-80);
}

.modal.create-session .template-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-left: 32px;
}

.modal.create-session .template-dropdown {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 10px;
    background-color: var(--black-10);
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
}

.modal.create-session .template-dropdown:hover {
    background-color: var(--black-15);
}

.modal.create-session .template-dropdown .selected {
    font-size: 14px;
    color: var(--black-80);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.modal.create-session .template-dropdown .arrow {
    font-family: 'Material Symbols Outlined';
    font-size: 20px;
    color: var(--black-65);
}

.modal.create-session .dropdown-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    max-height: 200px;
    overflow-y: auto;
    background-color: var(--black-05);
    border: 1px solid var(--black-15);
    border-radius: 4px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    z-index: 10;
}

.modal.create-session .dropdown-item {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    font-size: 14px;
    color: var(--black-80);
    cursor: pointer;
}

.modal.create-session .dropdown-item:hover {
    background-color: var(--black-15);
}

.modal.create-session .dropdown-item.selected {
    background-color: var(--black-15);
}

.modal.create-session .dropdown-item .locked {
    font-family: 'Material Symbols Outlined';
    font-size: 16px;
    margin-right: 6px;
    color: var(--black-45);
}

.modal.create-session .dropdown-item .locked.immutable {
    color: var(--black-80);
}

.modal.create-session .dropdown-item .name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.modal.create-session .checkbox-row {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;
}

.modal.create-session .checkbox-row.disabled {
    cursor: default;
}

.modal.create-session .checkbox-row.disabled .text {
    color: var(--black-45);
}

.modal.create-session .checkbox-row .checkbox {
    font-family: 'Material Symbols Outlined';
    font-size: 20px;
    color: var(--black-65);
}

.modal.create-session .checkbox-row.disabled .checkbox {
    color: var(--black-35);
}

.modal.create-session .checkbox-row .text {
    font-size: 14px;
    color: var(--black-80);
}

.modal.create-session .no-chains {
    font-style: italic;
    color: var(--black-45);
}

/* Hover tooltip, portalled to the body. Same surface as the popup menu, so a
   tip and a menu opened off the same control read as one family. */
.tip-anchor {
    display: inline-flex;
    align-items: center;
}

.tip {
    position: absolute;
    z-index: 1000;

    max-width: 220px;
    padding: 6px 8px;
    border-radius: 4px;

    font-size: 12px;
    font-weight: 500;
    line-height: 1.35;
    text-align: left;

    color: var(--black-80);
    background-color: var(--black-00);
    border: 1px solid var(--black-10);
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);

    /* the bubble must never steal the hover from its own anchor */
    pointer-events: none;
    transform: translateX(-50%);
}

.tip.above {
    transform: translate(-50%, -100%);
}
`, "",{"version":3,"sources":["webpack://./src/widgets.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;;IAEjB,qBAAqB;;IAErB,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,iCAAiC;IACjC,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;;IAEnB,iBAAiB;IACjB,kBAAkB;;IAElB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;6EAC6E;AAC7E;IACI,uEAAuE;AAC3E;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;;IAElB,YAAY;IACZ,kBAAkB;;IAElB,YAAY;IACZ,kBAAkB;;IAElB,UAAU;IACV,UAAU;;IAEV,iCAAiC;IACjC,eAAe;;IAEf,eAAe;IACf,iBAAiB;;AAErB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;;IAEZ,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;;IAE5D,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;;IAEjC,eAAe;;IAEf,aAAa;IACb,sBAAsB;IACtB,iCAAiC;IACjC,0CAA0C;;IAE1C,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA,wEAAwE;AACxE;;IAEI,2BAA2B;IAC3B,wBAAwB;IACxB,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;;;IAGI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;;IAEZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;;IAEZ,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;;sBAEsB;AACtB;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,wCAAwC;AACxC;IACI,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;;IAElB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;;IAEf,YAAY;IACZ,YAAY;IACZ,mFAAmF;IACnF,UAAU;IACV,kBAAkB;;IAElB,sBAAsB;IACtB,iCAAiC;;IAEjC,iCAAiC;IACjC,kBAAkB;;IAElB,yDAAyD;IACzD,aAAa;;IAEb,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,WAAW;AACf;;AAEA;oEACoE;AACpE;IACI,eAAe;IACf,SAAS;IACT,oEAAoE;IACpE,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,YAAY;IACZ,gBAAgB;AACpB;;AAEA,0EAA0E;AAC1E;IACI,6BAA6B;IAC7B,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,gCAAgC;;IAEhC,oBAAoB;;IAEpB,sBAAsB;IACtB,oCAAoC;;IAEpC,kCAAkC;IAClC,qCAAqC;;AAEzC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qCAAqC;;IAErC,+CAA+C;IAC/C,8CAA8C;;IAE9C,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB;;kCAE8B;IAC9B,sBAAsB;;IAEtB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;;IAEnB,2CAA2C;;IAE3C,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB;;yEAEqE;IACrE,WAAW;IACX,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB;8CAC0C;IAC1C,cAAc;IACd,sBAAsB;IACtB,0EAA0E;AAC9E;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;2EAE2E;AAC3E;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,WAAW;;IAEX,YAAY;IACZ,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;;IAEnB,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,yEAAyE;AACzE;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,6CAA6C;IAC7C,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;oCACoC;AACpC;IACI,iCAAiC;IACjC,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,yCAAyC;IACzC,kDAAkD;AACtD;;AAEA;;IAEI,kDAAkD;IAClD,uBAAuB;AAC3B;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;;IAEI,uCAAuC;AAC3C;;AAEA;0EAC0E;AAC1E;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA,gGAAgG;AAChG;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,SAAS;AACb;;AAEA,uCAAuC;AACvC;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,0BAA0B;AAC9B;;AAEA,0BAA0B;AAC1B,mBAAmB;;AAEnB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,iCAAiC;IACjC,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA,mCAAmC,QAAQ,EAAE;AAC7C,iCAAiC,gBAAgB,EAAE,QAAQ,EAAE,sBAAsB,EAAE;AACrF,+BAA+B,eAAe,EAAE,eAAe,EAAE;AACjE,iCAAiC,eAAe,EAAE;;AAElD;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;AACrB;AACA,wCAAwC,eAAe,EAAE;AACzD,8CAA8C,sBAAsB,EAAE;AACtE;IACI,wCAAwC;IACxC,eAAe;IACf,sBAAsB;AAC1B;AACA,kDAAkD,sBAAsB,EAAE;AAC1E,qCAAqC,eAAe,EAAE,sBAAsB,EAAE;;AAE9E,0BAA0B;;AAE1B;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,OAAO;AACX;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;IACjC,iCAAiC;IACjC,kBAAkB;IAClB,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;mEACmE;AACnE;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;;IAEb,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;;IAElB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;;IAEhB,sBAAsB;IACtB,iCAAiC;IACjC,iCAAiC;IACjC,0CAA0C;;IAE1C,8DAA8D;IAC9D,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,iCAAiC;AACrC","sourcesContent":["\nhtml {\n    overflow: hidden;\n}\n\n.editable.icon {\n    display: flex;\n}\n\n.editable.icon::after {\n    color: var(--black-25);\n    content: '\\e3c9';\n    font-size: 20px;\n    position: relative;\n    width: 18px;\n    top: -4px;\n    right: -3px;\n    overflow: hidden;\n    font-family: 'Material Symbols Outlined';\n}\n\n.editable.error.icon::after {\n    color: var(--red-1);\n}\n\n.editable.icon:has(.edit)::after {\n    display: none;\n}\n\n.editable.error {\n    color: var(--red-1);\n    text-decoration:underline wavy;\n    z-index: 999;\n    position: relative;\n}\n\n.editable > .empty {\n    font-style: italic;\n    color: var(--black-35);\n}\n\n.editable > .error {\n    display: none;\n    z-index: 999;\n    position:absolute;\n\n    text-decoration: none;\n\n    min-width: 160px;\n    bottom: -30px;\n    left: 0px;\n    background-color: var(--black-05);\n    color: var(--red-1);\n    padding-left: 4px;\n    padding-right: 4px;\n    padding-bottom: 6px;\n\n    border: solid 1px;\n    border-radius: 8px;\n\n    cursor: pointer;\n    user-select: none; \n}\n\n.editable.error:hover > .error  {\n    display: block;\n}\n\n.editable > .error::before {\n    content: '\\e645';\n    font-size: 15px;\n    position: relative;\n    top: 3px;\n    overflow: hidden;\n    font-family: 'Material Symbols Outlined';\n}\n\n.snapper {\n    position: relative;\n    border-radius: 4px;\n    background-color: var(--black-10);\n    padding-left: 4px;\n}\n\n/* The session picker opens its menu on click. The open menu is a descendant, so\n   a plain :hover would stay lit while the pointer is down inside the menu. */\n.snapper:not(:has(> .snap-menu)):hover {\n    background-image: linear-gradient(var(--hover-veil), var(--hover-veil));\n}\n\n.snapper.midi-learn::after {\n    height: 100%;\n    width: 100%;\n}\n\n.snapper .fullname {\n    display:none;\n    position: absolute;\n\n    height: 20px;\n    width: fit-content;\n\n    padding: 6px;\n    border-radius: 4px;\n\n    left: -4px;\n    top: -10px;\n\n    background-color: var(--black-15);\n    font-size: 10px;\n\n    cursor: pointer;\n    user-select: none; \n\n}\n\n.snapper > .name {\n    font-size: 13px;\n    font-weight: 500;\n    letter-spacing: 0.325px;\n    color: var(--black-75);\n    padding-left: 6px;\n    width: 168px;\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 70%, transparent 100%);\n\n    user-select: none; \n}\n\n.snapper > .expando {\n    position: absolute;\n    right: 4px;\n    font-size: 24px;\n    font-weight: normal;\n}\n\n.snapper > .snap-menu {\n    z-index: 999;\n    position: absolute;\n    padding-bottom: 10px;\n    padding-left: 6px;\n    left: -6px;\n    top: 34px;\n    width: 282px;\n    border-radius: 4px;\n    border: 1px solid var(--black-10);\n\n    font-size: 14px;\n\n    display: flex;\n    flex-direction: column;\n    background-color: var(--black-02);\n    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);\n\n    max-height: min(1200px, 90vh);\n    overflow: visible;\n}\n\n/* Override inline positioning and visual styles on nested MenuChoices */\n.snapper > .snap-menu > .menu-list,\n.snapper > .snap-menu > .sessions-scroll > .menu-list {\n    position: static !important;\n    z-index: auto !important;\n    /* Remove visual separators */\n    border: none;\n    border-radius: 0;\n    background: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.snapper > .snap-menu > .sessions-scroll {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n}\n\n.snapper > .snap-menu .action,\n.snapper > .snap-menu .session,\n.snapper > .snap-menu .header {\n    cursor: pointer;\n    user-select: none; \n}\n\n.snapper > .snap-menu .action.submenu {\n    display: flex;\n    justify-content: space-between;\n}\n\n.snapper > .snap-menu .action.submenu .trigger {\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n.snapper > .snap-menu .action,\n.snapper > .snap-menu .session {\n    color: var(--black-80);\n}\n\n.snapper > .snap-menu .session,\n.snapper > .snap-menu .search {\n    padding-left: 10px;\n}\n\n.snapper > .snap-menu .header {\n    font-size: 14px;\n    color: var(--black-45);\n}\n\n.snapper > .snap-menu .session {\n    position: relative;\n    width: 264px;\n\n    display: flex;\n    align-items: center;\n}\n\n.snapper > .snap-menu .session.empty {\n    font-style: italic;\n    color: var(--black-45);\n}\n\n.snapper > .snap-menu .session .name {\n    width: 204px;\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 70%, transparent 100%);\n}\n\n.snapper > .snap-menu .session .locked.immutable {\n    color: var(--black-80);\n}\n\n.snapper > .snap-menu .session .loaded,\n.snapper > .snap-menu .session .locked {\n    position: absolute;\n    font-family: 'Material Symbols Outlined';\n    font-size: 18px;\n}\n\n.snapper > .snap-menu .session .loaded {\n    right: 5px;\n}\n\n.snapper > .snap-menu .session .locked {\n    right: 24px;\n}\n\n/* Row without the check (the `loaded` class sits on the row, the icon is a\n   child of the same name): the lock takes the check's slot instead of hanging\n   short of the edge */\n.snapper > .snap-menu .session:not(.loaded) .locked {\n    right: 5px;\n}\n\n.snapper > .snap-menu .snaps .header {\n    color: var(--black-45);\n    font-size: 12px;\n}\n\n.snapper > .snap-menu .snaps .items {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n/* compensate for padding of container */\n.snapper > .snap-menu .snaps .items > .session:first-child {\n    padding-top: 3px;\n}\n\n.snapper > .snap-menu .action:not(.disabled):hover,\n.snapper > .snap-menu .session:hover {\n    color: var(--black-90);\n    background-color: var(--black-20);\n    border-radius: 2px;\n}\n\n.snapper > .snap-menu .action.disabled {\n    color: var(--black-45);\n}\n\n.snapper > .snap-menu .action {\n    position: relative;\n\n    display: flex;\n    align-items: center;\n}\n\n.snapper > .snap-menu .search {\n    padding-left: 7px;\n}\n\n.snapper > .snap-menu .search .icon {\n    position: absolute;\n    left: 14px;\n    font-size: 22px;\n    color: var(--black-45);\n    user-select: none; \n}\n\n.snapper > .snap-menu .searchbox {\n    font-size: 14px;\n  \n    width: 250px;\n    height: 32px;\n    /** if missing, caret appears in upper left of searchbox when empty (and focused) */\n    padding: 0;\n    padding-left: 33px;\n\n    color: var(--black-65);\n    background-color: var(--black-10);\n\n    border: solid var(--black-15) 1px;\n    border-radius: 4px;\n\n    /** prevents default outlining of active input text box */\n    outline: none;\n\n    text-align: left;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.snapper > .snap-menu .searchbox {\n    letter-spacing: 0;\n}\n\n.snapper > .snap-menu .searchbox.hidden {\n    display: none;\n}\n  \n.snapper > .snap-menu .searchbox.empty {\n    color: var(--black-45);\n    user-select: none; \n}\n\n.snapper > .snap-menu .searchbox.edit {\n    font-style: normal;\n    text-overflow: clip;\n    overflow: hidden;\n    color: var(--black-80);\n    background-color: var(--black-20);\n}\n\n.snapper > .snap-menu .action .icon {\n    font-family: 'Material Symbols Outlined';\n    font-size: 18px;\n    width: 24px;\n}\n\n/* Status banner under the header (Figma \"Frame 622\", node 3463:60780):\n   red wash, red text, chevron collapse. Spans the content column. */\n.app-banner {\n    position: fixed;\n    top: 72px;\n    /* Gosta (round 6): one 20px inset for all tabs/buttons and chains */\n    left: 400px;\n    right: 24px;\n    padding: 6px 12px 14px;\n    border-radius: 4px;\n    z-index: 5;\n    user-select: none;\n}\n\n.app-banner.danger {\n    background-color: rgba(255, 0, 0, 0.15);\n    color: #d90b0b;\n}\n\n.app-banner .head {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n}\n\n.app-banner .chevron {\n    font-size: 24px;\n}\n\n.app-banner .title {\n    font-size: 13px;\n    font-weight: 700;\n    letter-spacing: 0.26px;\n}\n\n.app-banner .body {\n    font-size: 13px;\n    letter-spacing: 0.26px;\n    padding-left: 32px;\n    margin-top: 2px;\n}\n\n.app-banner.collapsed {\n    padding-bottom: 6px;\n}\n\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.6);\n    z-index: 999;\n    overflow: hidden;\n}\n\n/* Non-blocking variant: click-through overlay, dialog still interactive */\n.modal.offline {\n    background-color: transparent;\n    pointer-events: none;\n}\n.modal.offline .dialog {\n    pointer-events: auto;\n}\n\n.modal .dialog {\n    font-size: 14px;\n    position: absolute;\n    top: 33%;\n    left: 50%;\n    width: 400px;\n    transform: translate(-50%, -50%);\n\n    padding-bottom: 10px;\n\n    color: var(--black-80);\n    background-color: var(--ui-modal-bg);\n\n    box-shadow: var(--ui-modal-shadow);\n    border-radius: var(--ui-modal-radius);\n\n}\n\n.modal .dialog .titlebar {\n    position: relative;\n    width: 100%;\n    height: var(--ui-modal-header-height);\n\n    border-top-right-radius: var(--ui-modal-radius);\n    border-top-left-radius: var(--ui-modal-radius);\n\n    font-size: 15px;\n    font-weight: 700;\n    text-transform: uppercase;\n    /* Explicit: Figma titlebar text is #cdcdce (var --Color). Without this\n       the title inherits whatever body color a dialog variant sets, e.g. the\n       demo dialog's --black-65. */\n    color: var(--black-80);\n\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n\n    background-color: var(--ui-modal-header-bg);\n\n    user-select: none;\n}\n\n.modal .dialog .titlebar .dismiss {\n    position: absolute;\n    /* 10px inset and the thin (wght 300) close glyph per Figma nodes\n       3495:40276 / 3495:40243. font-weight must match the 300 face:\n       the titlebar's 700 would synthetic-bold the glyph back to thick. */\n    right: 10px;\n    top: 5px;\n    font-size: 24px;\n    font-weight: 300;\n    /* 24x24 box like the Figma icon; line-height normal would grow it to\n       29px and sink the glyph below center. */\n    line-height: 1;\n    color: var(--black-80);\n    font-family: 'Material Symbols Outlined Thin', 'Material Symbols Outlined';\n}\n\n.modal .dialog .titlebar .dismiss:hover {\n    filter: brightness(1.2);\n}\n\n/* Figma dialog body copy: Inter Medium 15px, --black-85, 2.5% tracking\n   (node 3495:40276). Keep this low-specificity so purpose-built dialogs can\n   override the shared type scale without duplicating the base treatment. */\n.modal .dialog > .body > :where(.prompt, .message) {\n    font-weight: 500;\n    font-size: 15px;\n    line-height: normal;\n    letter-spacing: 0.025em;\n    color: var(--black-85);\n}\n\n.modal .dialog > .body > .prompt {\n    user-select: none;\n    padding: 10px;\n    width: 100%;\n\n    display:flex;\n    align-content: center;\n    justify-content: center;\n    text-align: center;\n}\n\n.modal .dialog .edit {\n    background-color: var(--black-02);\n    padding: 5px;\n    border-radius: 6px;\n}\n\n.modal .dialog > .body > .prompt > ul > li {\n    list-style-type: square;\n}\n\n.modal .dialog > .body {\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-top: 14px;\n    margin-bottom: 14px;\n\n    display:flex;\n    flex-direction: column;\n    justify-content: space-around;\n    gap: 18px;\n}\n\n.modal .dialog > .body .message {\n    padding-left: 10px;\n    white-space: pre-line;\n}\n\n/* Figma dialog footer: 120px buttons with an 8px gap (node 3495:40276) */\n.modal .dialog .actions {\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n}\n\n.modal .dialog .actions .cta {\n    width: 120px;\n    height: 32px;\n    background-color: var(--ui-button-bg-primary);\n    color: var(--ui-button-text-primary);\n}\n\n.modal .dialog .actions .cta.secondary {\n    background-color: transparent;\n    color: var(--ui-button-text-secondary);\n}\n\n/* Disabled reads as inert: gray fill, dim label — not the primary blue with\n   washed-out text it used to keep */\n.modal .dialog .actions .cta.disabled  {\n    background-color: var(--black-15);\n    color: var(--black-45);\n    font-weight: normal;\n}\n\n.modal .dialog .actions .cta.selected:not(.disabled) {\n    border: 2px solid var(--black-45);\n    font-weight: 500;\n}\n\n.modal .dialog .actions .cta:hover:not(.disabled) {\n    color: var(--ui-button-text-primary);\n    filter: brightness(1.1);\n}\n\n.modal .dialog .actions .cta.secondary:hover {\n    color: var(--black-80);\n    filter: none;\n}\n\n.modal .dialog .actions .cta:hover.disabled {\n    background-color: var(--black-15);\n}\n\n.modal .dialog.alert {\n    width: 360px;\n}\n\n.modal .dialog.alert .titlebar,\n.modal .dialog.destructive .titlebar {\n    background-color: var(--ui-modal-header-bg-danger);\n    color: var(--ui-modal-header-text-danger);\n}\n\n.modal .dialog.alert .actions {\n    justify-content: center;\n}\n\n.modal .dialog.alert .actions .cta,\n.modal .dialog.destructive .actions .cta.primary {\n    color: var(--ui-modal-header-text-danger);\n    background-color: var(--ui-modal-header-bg-danger);\n}\n\n.modal .dialog.alert .actions .cta:hover,\n.modal .dialog.destructive .actions .cta.primary:hover {\n    background-color: var(--ui-modal-header-bg-danger);\n    filter: brightness(1.1);\n}\n\n.modal .dialog.alert .dismiss,\n.modal .dialog.destructive .dismiss {\n    color: var(--ui-modal-header-text-danger);\n}\n\n.modal .dialog.destructive .actions .cta.secondary.danger,\n.modal .dialog.destructive .actions .cta.secondary.danger:hover {\n    color: var(--ui-modal-header-bg-danger);\n}\n\n/* The three-outcome Save Changes flow only needs room for its third CTA.\n   Typography and alignment come from the shared dialog treatment above. */\n.modal .dialog.destructive.three-outcome {\n    width: 460px;\n}\n\n.modal .dialog.alert > .body .message {\n    text-align: center;\n    padding-inline: 10px;\n}\n\n/* OFFLINE dialog uses the app-chrome blue, not the dialog header blue (Figma node 3495:40286) */\n.modal.offline .dialog .titlebar {\n    background-color: var(--blue-1);\n}\n\n.modal.offline .dialog .actions .cta {\n    background-color: var(--blue-1);\n    color: var(--black-80);\n}\n\n.modal.offline .dialog .actions .cta.secondary {\n    background-color: transparent;\n    color: var(--ui-button-text-secondary);\n}\n\n.modal .dialog.alert > .body {\n    margin: 24px 20px 20px;\n    gap: 20px;\n}\n\n/* App Info Dialog - Enhanced Styling */\n.modal .dialog.app-info-dialog {\n    width: 420px;\n}\n\n.modal .dialog.app-info-dialog > .body {\n    gap: 16px;\n}\n\n.modal .dialog.app-info-dialog .prompt {\n    font-size: 13px;\n    color: var(--black-65);\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    margin-bottom: 4px;\n}\n\n.app-info-content {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.app-info-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 10px 12px;\n    background: var(--black-02);\n    border-radius: 4px;\n}\n\n.app-info-row {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n}\n\n.app-info-key {\n    min-width: 90px;\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--black-45);\n    text-transform: lowercase;\n    letter-spacing: 0.02em;\n}\n\n.app-info-key::after {\n    content: ':';\n}\n\n.app-info-value {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--black-80);\n    letter-spacing: 0.025em;\n}\n\n.release-notes-link {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 10px 16px;\n    margin-top: 4px;\n    background: var(--black-02);\n    border: 1px solid var(--black-15);\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    font-size: 13px;\n    color: var(--black-65);\n}\n\n.release-notes-link:hover {\n    background: var(--black-07);\n    border-color: var(--blue-2);\n    color: var(--black-80);\n}\n\n.release-notes-icon {\n    font-size: 8px;\n    color: var(--blue-2);\n    opacity: 0.7;\n}\n\n.release-notes-link:hover .release-notes-icon {\n    opacity: 1;\n}\n\n.release-notes-chevron {\n    font-size: 16px;\n    margin-left: auto;\n    opacity: 0.5;\n    transition: transform 0.15s ease;\n}\n\n.release-notes-link:hover .release-notes-chevron {\n    opacity: 1;\n    transform: translateX(2px);\n}\n\n/* Create Session Dialog */\n/* SUPPORT DIALOG */\n\n.modal.support .field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.modal.support .field .field-label {\n    font-size: 13px;\n    color: var(--black-65);\n    font-weight: 500;\n}\n\n.modal.support .field .value {\n    background-color: var(--black-10);\n    padding: 8px 10px;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.modal.support .support-input,\n.modal.support .support-message {\n    background-color: var(--black-10);\n    color: inherit;\n    font-family: inherit;\n    font-size: 14px;\n    padding: 8px 10px;\n    border-radius: 4px;\n    border: none;\n    outline: none;\n    resize: vertical;\n}\n\n.modal.support .app-info-content { gap: 6px; }\n.modal.support .app-info-group { padding: 5px 8px; gap: 2px; border-left-width: 2px; }\n.modal.support .app-info-key { font-size: 10px; min-width: 70px; }\n.modal.support .app-info-value { font-size: 11px; }\n\n.modal.support .prompt {\n    font-size: 11px;\n    font-weight: 400;\n    color: var(--black-40);\n}\n\n.modal.support .support-input.error {\n    outline: 1px solid #c54040;\n}\n\n.modal.support .version-stale {\n    font-size: 11px;\n    color: #c57600;\n    font-weight: 500;\n    margin-top: 2px;\n}\n\n.modal.support .checkbox-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    user-select: none;\n}\n.modal.support .checkbox-row.disabled { cursor: default; }\n.modal.support .checkbox-row.disabled .text { color: var(--black-45); }\n.modal.support .checkbox-row .checkbox {\n    font-family: 'Material Symbols Outlined';\n    font-size: 20px;\n    color: var(--black-65);\n}\n.modal.support .checkbox-row.disabled .checkbox { color: var(--black-35); }\n.modal.support .checkbox-row .text { font-size: 14px; color: var(--black-80); }\n\n/* CREATE SESSION DIALOG */\n\n.modal.create-session .dialog {\n    width: 420px;\n}\n\n.modal.create-session .dialog .body {\n    gap: 16px;\n}\n\n.modal.create-session .field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.modal.create-session .field .label {\n    font-size: 13px;\n    color: var(--black-65);\n    font-weight: 500;\n}\n\n.modal.create-session .field .value {\n    background-color: var(--black-10);\n    padding: 8px 10px;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.modal.create-session .options {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.modal.create-session .option {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 12px;\n    border-radius: 4px;\n    background-color: var(--black-05);\n    cursor: pointer;\n    user-select: none;\n}\n\n.modal.create-session .option:hover {\n    background-color: var(--black-15);\n}\n\n.modal.create-session .option.selected {\n    background-color: var(--black-15);\n}\n\n.modal.create-session .option .radio {\n    font-family: 'Material Symbols Outlined';\n    font-size: 20px;\n    color: var(--black-65);\n}\n\n.modal.create-session .option.selected .radio {\n    color: var(--blue-2);\n}\n\n.modal.create-session .option .text {\n    font-size: 14px;\n    color: var(--black-80);\n}\n\n.modal.create-session .template-section {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding-left: 32px;\n}\n\n.modal.create-session .template-dropdown {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 10px;\n    background-color: var(--black-10);\n    border-radius: 4px;\n    cursor: pointer;\n    user-select: none;\n}\n\n.modal.create-session .template-dropdown:hover {\n    background-color: var(--black-15);\n}\n\n.modal.create-session .template-dropdown .selected {\n    font-size: 14px;\n    color: var(--black-80);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1;\n}\n\n.modal.create-session .template-dropdown .arrow {\n    font-family: 'Material Symbols Outlined';\n    font-size: 20px;\n    color: var(--black-65);\n}\n\n.modal.create-session .dropdown-list {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    max-height: 200px;\n    overflow-y: auto;\n    background-color: var(--black-05);\n    border: 1px solid var(--black-15);\n    border-radius: 4px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n    z-index: 10;\n}\n\n.modal.create-session .dropdown-item {\n    display: flex;\n    align-items: center;\n    padding: 8px 10px;\n    font-size: 14px;\n    color: var(--black-80);\n    cursor: pointer;\n}\n\n.modal.create-session .dropdown-item:hover {\n    background-color: var(--black-15);\n}\n\n.modal.create-session .dropdown-item.selected {\n    background-color: var(--black-15);\n}\n\n.modal.create-session .dropdown-item .locked {\n    font-family: 'Material Symbols Outlined';\n    font-size: 16px;\n    margin-right: 6px;\n    color: var(--black-45);\n}\n\n.modal.create-session .dropdown-item .locked.immutable {\n    color: var(--black-80);\n}\n\n.modal.create-session .dropdown-item .name {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.modal.create-session .checkbox-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    user-select: none;\n}\n\n.modal.create-session .checkbox-row.disabled {\n    cursor: default;\n}\n\n.modal.create-session .checkbox-row.disabled .text {\n    color: var(--black-45);\n}\n\n.modal.create-session .checkbox-row .checkbox {\n    font-family: 'Material Symbols Outlined';\n    font-size: 20px;\n    color: var(--black-65);\n}\n\n.modal.create-session .checkbox-row.disabled .checkbox {\n    color: var(--black-35);\n}\n\n.modal.create-session .checkbox-row .text {\n    font-size: 14px;\n    color: var(--black-80);\n}\n\n.modal.create-session .no-chains {\n    font-style: italic;\n    color: var(--black-45);\n}\n\n/* Hover tooltip, portalled to the body. Same surface as the popup menu, so a\n   tip and a menu opened off the same control read as one family. */\n.tip-anchor {\n    display: inline-flex;\n    align-items: center;\n}\n\n.tip {\n    position: absolute;\n    z-index: 1000;\n\n    max-width: 220px;\n    padding: 6px 8px;\n    border-radius: 4px;\n\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.35;\n    text-align: left;\n\n    color: var(--black-80);\n    background-color: var(--black-00);\n    border: 1px solid var(--black-10);\n    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);\n\n    /* the bubble must never steal the hover from its own anchor */\n    pointer-events: none;\n    transform: translateX(-50%);\n}\n\n.tip.above {\n    transform: translate(-50%, -100%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
